import { render, staticRenderFns } from "./QnATitle.vue?vue&type=template&id=1e428d48"
import script from "./QnATitle.vue?vue&type=script&lang=js"
export * from "./QnATitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports